import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface TableData {
  key: string;
  foc: string;
  base?: string;
  gro?: string;
  pro?: string;
  proPlus?: string;
}
export interface CategoryData {
  key: string;
  branding: string;
  attendance: string;
  payment: string;
  privilege: string;
  proPlus: string;
}
interface FocMasterState {
  tableData: TableData[];
  categoryData: CategoryData[];
  editingRecord: TableData | null;
  editingCategory: CategoryData | null;
  isModalVisible: boolean;
  isCategoryModalVisible: boolean;
  loading: boolean;
  error: string | null;
}
const initialState: FocMasterState = {
  tableData: [
    { key: "1", foc: "80", base: "2", gro: "4", pro: "6", proPlus: "7" },
  ],
  categoryData: [
    {
      key: "1",
      branding: "2",
      attendance: "2",
      payment: "2",
      privilege: "1",
      proPlus: "1",
    },
  ],
  editingRecord: null,
  editingCategory: null,
  isModalVisible: false,
  isCategoryModalVisible: false,
  loading: false,
  error: null,
};
const focMasterSlice = createSlice({
  name: "focMaster",
  initialState,
  reducers: {
    fetchFocMasterRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchFocMasterSuccess(
      state,
      action: PayloadAction<{
        tableData: TableData[];
        categoryData: CategoryData[];
      }>
    ) {
      state.loading = false;
      state.tableData = action.payload.tableData;
      state.categoryData = action.payload.categoryData;
    },
    fetchFocMasterFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    openEditModal(state, action: PayloadAction<TableData>) {
      state.editingRecord = action.payload;
      state.isModalVisible = true;
    },
    closeEditModal(state) {
      state.isModalVisible = false;
      state.editingRecord = null;
    },
    openCategoryEditModal(state, action: PayloadAction<CategoryData>) {
      state.editingCategory = action.payload;
      state.isCategoryModalVisible = true;
    },
    closeCategoryEditModal(state) {
      state.isCategoryModalVisible = false;
      state.editingCategory = null;
    },
    saveTableData(state, action: PayloadAction<TableData>) {
      const index = state.tableData.findIndex(
        (item) => item.key === action.payload.key
      );
      if (index !== -1) {
        state.tableData[index] = action.payload;
      }
      state.isModalVisible = false;
      state.editingRecord = null;
    },
    saveCategoryData(state, action: PayloadAction<CategoryData>) {
      const index = state.categoryData.findIndex(
        (item) => item.key === action.payload.key
      );
      if (index !== -1) {
        state.categoryData[index] = action.payload;
      }
      state.isCategoryModalVisible = false;
      state.editingCategory = null;
    },
  },
});
export const {
  fetchFocMasterRequest,
  fetchFocMasterSuccess,
  fetchFocMasterFailure,
  openEditModal,
  closeEditModal,
  openCategoryEditModal,
  closeCategoryEditModal,
  saveTableData,
  saveCategoryData,
} = focMasterSlice.actions;
export default focMasterSlice.reducer;
